function cov_awhelbnxg() {
  var path = "/app/src/types/currency.ts";
  var hash = "9068cbf0deb807d8471bce0c72d8e2e9494274ce";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/currency.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 28
        },
        end: {
          line: 7,
          column: 10
        }
      },
      "1": {
        start: {
          line: 11,
          column: 33
        },
        end: {
          line: 15,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9068cbf0deb807d8471bce0c72d8e2e9494274ce"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_awhelbnxg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_awhelbnxg();
export var CurrencyType = (cov_awhelbnxg().s[0]++, {
  AED: 'AED',
  KWD: 'KWD',
  SAR: 'SAR',
  BHD: 'BHD',
  QAR: 'QAR'
});
export var allowedCurrencies = (cov_awhelbnxg().s[1]++, [CurrencyType.AED, CurrencyType.SAR, CurrencyType.KWD]);